import {IServerData} from '~/interfaces/serverInterfaces'
import jqXHR = JQuery.jqXHR

interface IServerActionArgs {
  endpoint?: string
  method?: string
  json?: object
  data?: string | object // only provide string when there is no json provided
  dataType?: 'json' | 'html'
}

export default function serverAction<U>({endpoint = '', method = 'get', json = null, dataType = 'json', data = {_method: method}}: IServerActionArgs): Promise<IServerData<U>> {
  return new Promise<IServerData<U>>((resolve, reject) => {
    if (json) {
      window.AppConfig.mergeJson(data, json);
    }

    $.ajax({
      url: endpoint.startsWith('/') ? endpoint : `/${endpoint}`,
      type: method || 'POST',
      dataType: dataType,
      data: data,
      headers: {
        'X-CSRF-Token': document.querySelector<HTMLMetaElement>('meta[name=csrf-token]')?.content
      }
    }).done(function (serverData: U, statusText: string, xhr: jqXHR) {
      resolve([serverData, statusText, xhr]);
    }).fail(reject);
  });
}
